export class EventoCalendario {
  constructor({
    id = null,
    nome = null,
    corHexadecimal = '#000000',
    diaLetivo = false,
    ativo = null,
  }) {
    this.id = id;
    this.nome = nome;
    this.corHexadecimal = corHexadecimal;
    this.diaLetivo = diaLetivo;
    this.ativo = ativo;
  }
  static Build() {
    return new EventoCalendario({
      id: null,
      nome: null,
      corHexadecimal: '#000000',
      diaLetivo: false,
      ativo: null,
    });
  }
  format() {
    return this;
  }
}
